import { Mapping } from 'api/MappingsAPI';
import { ContactProperty } from 'modules/domains';

export const getContactProperty = (mapping: Mapping): ContactProperty => ({
  name: mapping.fieldName,
  type: mapping.fieldType,
});
